<template>
	<div class="toggle-register-or-login" :class="className" @click="$emit('update:value', !value)">
		<div class="toggle-text">Register/Login for this Order</div>
		<div class="toggle-icon" v-show="value"></div>
	</div>
</template>

<script>
	export default {
		name: 'toggle-register-or-login',
		props: {
			value: Boolean,
			whitebackdrop: Boolean
		},
		computed: {
			className() {
				return this.whitebackdrop ? 'white-color' : '';
			}
		}
	}
</script>

<style scoped lang="less">
	.toggle-register-or-login{
		width: 100%;
		height: 50px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.toggle-text{
			position: relative;
			&::before{
				content: '';
				position: absolute;
				left: 0;
				bottom: -3px;
				width: 100%;
				height: 1px;
				transform: scale(1, 0.5);
				background-color: transparent;
				transition: background-color 300ms ease-in;
			}
			&:hover::before{
				background-color: #FFFFFF;
			}
		}
		.toggle-icon{
			width: 16px;
			height: 16px;
			position: relative;
			&::before, &::after{
				content: '';
				position: absolute;
				height: 1px;
				transform-origin: 0 0;
				background-color: #FFFFFF;
			}
			&::before{
				width: 36%;
				left: 20%;
				top: 60%;
				transform: translateY(-50%) rotate(33.7deg);
			}
			&::after{
				width: 67%;
				left: 80%;
				top: 20%;
				transform: translateY(-50%) rotate(116.56deg);
			}
		}
	}
	.white-color{
		.toggle-text{
			color: #000000;
			&:hover::before{
				background-color: #000000;
			}
		}
		.toggle-icon{
			&::before, &::after{
				background-color: #000000;
			}
		}
	}
</style>
